
import makerjs from "makerjs";
function B17(model,zoom,Param,fixedParam){
  //w,h,w1,w2
  console.log("Param==",Param[0].param);
  console.log("Param==",Param[1].param);
  console.log("Param==",Param);
    var plate=model.plate,markers=model.markers,myZoom=zoom*1,
    B = Param[0].param,L = Param[1].param,T = Param[2].param,R = Param[3].param, 
      //  plate = model.plate, markers = model.markers,
       markShift = fixedParam.markShift*1, markShiftTwo = fixedParam.markShiftTwo*1,
       markShiftThree = fixedParam.markShiftThree*1, markShiftFour = fixedParam.markShiftFour*1, markHolesOneD = fixedParam.markHolesOneD*1,

       b = B * 1 * myZoom,
       l = L * 1 * myZoom,
       t = T * 1 * myZoom,
        r = R * 1 * myZoom,
       // x0 = X*1*myZoom,
       // y0 = Y*1*myZoom;
       
       x0 = 0, x1 = 0, x2 =t ,x3 =b ,x4 =b , y0 = 0, y1 = r,y2 = l, y3 =r,y4 =0,glassH =l, glassW = b,h=l,w=b;

   if (b !== 0) {
       var TxtB ="B="+ B;
   }  if (l !== 0) {
    var TxtL = "L="+L;
  }  if (r !== 0) {
    var TxtR = "R="+R;
  }  if (t !== 0) {
    var TxtT = "T="+T;
  } 



   var drawAbnormalShapeB17 = {
       paths: {
        "LeftLine": new makerjs.paths.Line([x0, y0], [x1, y1]),
        "TopLineLeft":new makerjs.paths.Line([x1,y1], [x2,y2]),
        "TopLineRight":new makerjs.paths.Line([x2,y2], [x3,y3]), 
        "RightLine":new makerjs.paths.Line([x3,y3], [x4,y4]), 
        "BottomLine": new makerjs.paths.Line([x4,y4], [x0, y0]),
       }
   };
   var drawAbnormalShapeB17MarkL = {
       paths: {
        "RightLine": new makerjs.paths.Line([x0- markShift, y0], [x0- markShift, y2]),
        "RightShortUpline": new makerjs.paths.Line([x0, y2], [x0- 2 * markShift, y2]),
        "RightShortDnline": new makerjs.paths.Line([x0, y0], [x0- 2 * markShift, y0]),
       }
   };
   var drawAbnormalShapeB17MarkR = {
       paths: {
        "RightLine": new makerjs.paths.Line([x4+ markShift, y4], [x3+ markShift, y3]),
        "RightShortUpline": new makerjs.paths.Line([x3, y3], [x3+ 2 * markShift, y3]),
        "RightShortDnline": new makerjs.paths.Line([x4, y4], [x4+ 2 * markShift, y4]),
       }
   };
   var drawAbnormalShapeB17MarkB = {
       paths: {
        "BottomLine": new makerjs.paths.Line([x0, y0- markShift], [x4, y4- markShift]),
        "BotmShortLfline": new makerjs.paths.Line([x0, y0], [x0, y0 - 2 * markShift]),
        "BotmShortRTline": new makerjs.paths.Line([x4, y4], [x4, y4 - 2 * markShift]),
       }
  
   };
   var drawAbnormalShapeB17MarkT = {
       paths: {
        "BottomLine": new makerjs.paths.Line([x0, y0- 3*markShift], [x2, y0- 3*markShift]),
        "BotmShortLfline": new makerjs.paths.Line([x0, y0], [x0, y0 - 5 * markShift]),
        "BotmShortRTline": new makerjs.paths.Line([x2, y0], [x2, y0 - 5 * markShift]),
       }
  
   };
   makerjs.model.addCaption(drawAbnormalShapeB17MarkB, TxtB, [x0, y0 - 2 * markShift], [x4, y4 - 2 * markShift]);//长度文字
   makerjs.model.addCaption(drawAbnormalShapeB17MarkT, TxtT, [x0, y0- 5*markShift], [x2, y0- 5*markShift]);//长度文字
   makerjs.model.addCaption(drawAbnormalShapeB17MarkL, TxtL, [x0-2*markShift, y0], [x0-2*markShift, y2]);//宽度文字
   makerjs.model.addCaption(drawAbnormalShapeB17MarkR, TxtR, [x4+ 3*markShift, y4], [x3+ 3*markShift, y3]);//长度文字
   
  plate={
    models: {
      drawAbnormalShapeB17: drawAbnormalShapeB17,
      }
    };
    markers={
      models: {
        drawAbnormalShapeB17: drawAbnormalShapeB17,
        drawAbnormalShapeB17MarkL: drawAbnormalShapeB17MarkL,
        drawAbnormalShapeB17MarkT: drawAbnormalShapeB17MarkT,
        drawAbnormalShapeB17MarkR: drawAbnormalShapeB17MarkR,
        drawAbnormalShapeB17MarkB:drawAbnormalShapeB17MarkB,
        }
      };
    
   /*****************************************************************************/
   //return { plate, markers, glassW, glassH }
 
    return{w,h,plate, markers}  
};


export default B17;